import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="py-12 border-t border-border/50 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
          <div>
            <h4 className="text-sm font-medium text-white mb-3">Crystal Intelligence</h4>
           
          </div>
            <p className="text-sm text-slate-500 leading-relaxed">
              Advanced blockchain intelligence and asset investigation solutions for a safer digital economy.
            </p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-white mb-3">Solutions</h4>
            <ul className="space-y-2">
              <li><Link to="/services" className="text-sm text-slate-500 hover:text-white transition-colors">Investigations</Link></li>
              <li><Link to="/services" className="text-sm text-slate-500 hover:text-white transition-colors">Risk Analysis</Link></li>
              <li><Link to="/services" className="text-sm text-slate-500 hover:text-white transition-colors">Compliance</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-medium text-white mb-3">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-slate-500 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-sm text-slate-500 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/report-case" className="text-sm text-slate-500 hover:text-white transition-colors">Report a Case</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-medium text-white mb-3">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy-policy" className="text-sm text-slate-500 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-sm text-slate-500 hover:text-white transition-colors">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-border/50 pt-8">
          <p className="text-center text-xs text-slate-500">&copy; 2026 Crystal Intelligence. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
